import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Layout } from '@/components/layout/Layout';
import { Header } from '@/components/layout/header/Header';
import { ProfileUnifiedCard } from '@/components/profile/ProfileUnifiedCard';

export default function Profile() {
  useLanguage();
  return (
    <Layout fixedSidebar={true}>
      <div className="flex-1 flex flex-col bg-background lg:overflow-hidden mobile-scroll-fix">
        <Header title={translateInterfaceText("Meu Perfil")} />

        {/* Divisor horizontal padrão HostVSL */}
        <div className="hidden lg:block h-px bg-border w-full" />

        <main className="flex-1 lg:overflow-y-auto scrollbar-blue">
          <div className="p-4 md:p-6 pb-[calc(120px+env(safe-area-inset-bottom))] lg:pb-6 space-y-5 max-w-[1200px] mx-auto">
            <ProfileUnifiedCard />
          </div>
        </main>
      </div>
    </Layout>
  );
}